import { InternalTranslations } from "../types";

export const messages: InternalTranslations = {
  "urls.searchBaseUrl": "/events",
  "urls.eventBaseUrl": "/event",
  "urls.tagsBaseUrl": "/tags",
  "urls.seriesBaseUrl": "/c",
  "urls.destinationsBaseUrl": "/destinations",
  "urls.destinationsHubBaseUrl": "/destinations",
  "urls.blogBaseUrl": "/blog",
  "urls.disciplinesBaseUrl": "/activities",
  "urls.resultsPath": "results",
  "shared.PhoneNumbers.support": "+44 330 822 2143",
  "shared.Emails.contact": "contact@finishers.com",
  "shared.Emails.support": "hello@support.finishers.com",
  "shared.Emails.organizers.contact": "organisateur@finishers.com",
};
